import {
  useCompetencyLibQuery, useCustomManagementQuery, useListCompanyMemberQuery, useListLevelDescriptionQuery, useSkillGroupListQuery,
} from 'components/company/hooks/useCompany';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  HIT_COMPETENCY_LIB, HIT_COP_LIST, HIT_CUSTOM_MANAGEMENT, HIT_LIST_LEVEL_DESCRIPTION, HIT_LIST_MEMBER, HIT_LIST_SKILL_GROUP,
} from 'redux/actions/company';
import { HIT_LIST_DIRECTORATE, HIT_LIST_JOB } from 'redux/actions/organization';
import {
  HIT_ACTIVITY_TYPE_LIST, HIT_LIST_LIMIT_FTE, HIT_REGION_LIST, HIT_WLA_OC_LIST,
  HIT_WORKER_TYPE_LIST,
} from 'redux/actions/wla';

type TabConfigType = {
  id: number,
  key: string;
  type: string;
  getPayload: () => {
    board_id?: string
    company_id?: string
    limit?: number
    offset?: number
  };
};

export function useFetchCompetencyGroup(idTab: number) {
  useSkillGroupListQuery(idTab === 1);
}

export function useFetchOrganizationGroup(idTab: number) {
  const dispatch = useDispatch();
  const hasHit = useRef({
    directorate: false,
    region: false,
    orgParameter: false,
  });
  const companyId = localStorage.getItem('company_id');
  const boardId = localStorage.getItem('board_id');

  const tabConfig = {
    1: [{
      id: 1,
      key: 'directorate',
      type: HIT_LIST_DIRECTORATE,
      getPayload: () => ({}),
    }],
    2: [{
      id: 2,
      key: 'jobLevel',
      type: HIT_LIST_JOB,
      getPayload: () => ({ board_id: boardId }),
    }],
    3: [{
      id: 3,
      key: 'region',
      type: HIT_REGION_LIST,
      getPayload: () => ({ company_id: companyId }),
    }],
    4: [{
      id: 4,
      key: 'orgParameter',
      type: HIT_COP_LIST,
      getPayload: () => undefined,
    }],
  };

  useEffect(() => {
    const configs: TabConfigType[] = tabConfig[idTab] || [];

    configs.forEach(({
      id, key, type, getPayload,
    }) => {
      if (idTab === id && !hasHit.current[key]) {
        dispatch({
          type,
          payload: getPayload(),
        });
        hasHit.current[key] = true;
      }
    });
  }, [idTab]);
}

export function useFetchWLAGroup(idTab: number) {
  const dispatch = useDispatch();
  const hasHit = useRef({
    categoryGroup: false,
    classification: false,
    activityType: false,
    fte: false,
    workerType: false,
  });

  const tabConfig = {
    // 1: [{
    //   id: 1,
    //   key: 'categoryGroup',
    //   type: HIT_CUSTOM_MANAGEMENT,
    //   getPayload: () => undefined,
    // }],
    2: [{
      id: 2,
      key: 'classification',
      type: HIT_WLA_OC_LIST,
      getPayload: () => undefined,
    }],
    3: [{
      id: 3,
      key: 'activityType',
      type: HIT_ACTIVITY_TYPE_LIST,
      getPayload: () => undefined,
    }],
    4: [{
      id: 4,
      key: 'fte',
      type: HIT_LIST_LIMIT_FTE,
      getPayload: () => undefined,
    }],
    5: [{
      id: 5,
      key: 'workerType',
      type: HIT_WORKER_TYPE_LIST,
      getPayload: () => undefined,
    }],
  };

  useCustomManagementQuery(idTab === 1);

  useEffect(() => {
    const configs: TabConfigType[] = tabConfig[idTab] || [];

    configs.forEach(({
      id, key, type, getPayload,
    }) => {
      if (idTab === id && !hasHit.current[key]) {
        dispatch({
          type,
          payload: getPayload(),
        });
        hasHit.current[key] = true;
      }
    });
  }, [idTab]);
}

export function useFetchJobDescGroup() {
  const companyId = localStorage.getItem('company_id');
  const payloadJobDesc = {
    company_id: companyId,
  };

  useListLevelDescriptionQuery(payloadJobDesc, true);
}

export function useFetchMemberGroup() {
  useListCompanyMemberQuery(true);
}
